export default __webpack_public_path__ + "static/media/NotoSansKR-Black.25a7c746.woff2";